import React, {Component} from 'react';
import Payment from "../components/payment/payment";

const PaymentPage = () => {
    return (
        <Payment>
        </Payment>
    )
}

export default PaymentPage;
